var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDownThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.5C7.76064 12.5 7.55811 12.408 7.3832 12.2331L0.248562 4.94479C0.0920598 4.77914 0 4.57669 0 4.34663C0 3.8681 0.368239 3.5 0.846951 3.5C1.0771 3.5 1.28884 3.59202 1.44534 3.73926L8 10.4387L14.5547 3.73926C14.7112 3.59202 14.9321 3.5 15.153 3.5C15.6318 3.5 16 3.8681 16 4.34663C16 4.57669 15.9079 4.77914 15.7514 4.93558L8.6168 12.2331C8.4603 12.408 8.23015 12.5 8 12.5Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDownThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronDownThin.6232b3cd8899164955a13e6e49eecb8b.svg";